"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSchema = exports.arraySchema = exports.objectSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const error_1 = require("./error");
const HttpStatus_1 = require("../domain/HttpStatus");
const APIError_1 = require("../domain/APIError");
function objectSchema(schemaDef) {
    return joi_1.default.object(schemaDef);
}
exports.objectSchema = objectSchema;
function arraySchema(schemaDef) {
    return joi_1.default.array().items(schemaDef);
}
exports.arraySchema = arraySchema;
function validateSchema(obj, schema, throwOnError = true, options) {
    const { error, value } = schema.validate(obj, {
        ...options,
    });
    if (error) {
        if (throwOnError) {
            throw new APIError_1.APIError(HttpStatus_1.HTTPStatus.BAD_REQUEST, JSON.stringify((0, error_1.formatValidationError)(error)), error, (0, error_1.formatValidationError)(error));
        }
        else {
            return error;
        }
    }
    return value;
}
exports.validateSchema = validateSchema;
